export default {
  offers: {
    offersHeading: 'Standard Offers',
    discountAmount: 'Discount Amount',
    discountPercentage: 'Discount Percentage',
    noOffers:
      'No offers added yet. Click "Add New Offer" to create your first one.',
    saveSelectedOffers: 'Save Selected Offers',
    loading: 'Loading...',
    addNewOffer: 'Add New Offer',
    editOffer: 'Edit Offer',
    edit: 'Edit',
    remove: 'Remove',
    save: 'Save',
    saving: 'Saving...',
    saveOffers: 'Pay',
    create: 'Create',
    cancel: 'Cancel',
    description: 'Description',
    enterOfferName: 'Enter offer name',
    enterDescription: 'Describe the offer briefly',
    inclusions: 'Inclusions (one per line)',
    inclusionsPlaceholder: 'Booth furniture\nWiFi\n2 badges\nElectricity',
    inclusionsHelper: 'Enter each inclusion on a new line',
    successCreate: 'Offer created successfully',
    successUpdate: 'Offer updated successfully',
    successDelete: 'Offer deleted successfully',
    errors: {
      save: 'Failed to save offers. Please try again.',
      nameRequired: 'Please enter an offer name',
      priceInvalid: 'Please enter a valid price',
    },
  },
};
